module.exports = __webpack_public_path__ + "media/svg/coroa-finish-20c4b257.svg";